import { Component } from 'react';
import Footer from '../Footer';
import Header from '../Header';
import LeftNav from '../LeftNav';
import BarCodeScreen from '../../views/bar-code/Barcode';
import AuthorizationRoute from '../AuthorizationRoute';
import { getFromLocalStorage, saveToLocalStorage } from '../../utils/utils';

function AdminLayout(
  LoadedComponent,
  leftnav = true,
  header = true,
  footer = true
) {
  return class extends Component {
    constructor(props) {
      super(props);
      this.state = {
        isBarCodeVisible: false,
      };
      this.isNavbarCollapsed =
        getFromLocalStorage('isB2cNavbarCollapsed') || false;
    }

    toggleMenu = () => {
      const menu = document.querySelector('#showNav');
      if (menu.className === 'nav_show') {
        menu.className = 'nav_hide';
      } else {
        menu.className = 'nav_show';
      }
    };

    toggleBarCode = () => {
      this.setState({ isBarCodeVisible: true });
    };

    closeBarModal = () => {
      this.setState({ isBarCodeVisible: false });
    };

    handleNavCollapse = () => {
      const showNav = document.querySelector('#showNav');
      const toggleBtn = document.querySelector('.toggleNavBtn > i');
      const sidebarLinks = document.querySelectorAll('.list-unstyled li a');

      toggleBtn.classList.toggle('k-i-arrow-chevron-left');
      toggleBtn.classList.toggle('k-i-arrow-chevron-right');

      if (this.isNavbarCollapsed) {
        showNav.classList.remove('sidebar-collapsed');
        sidebarLinks.forEach((item) => item.removeAttribute('title'));
      } else {
        showNav.classList.add('sidebar-collapsed');
        sidebarLinks.forEach((item) => (item.title = item.textContent));
      }

      this.isNavbarCollapsed = !this.isNavbarCollapsed;
      saveToLocalStorage('isB2cNavbarCollapsed', this.isNavbarCollapsed);
    };

    render() {
      const collapsed = getFromLocalStorage('isB2cNavbarCollapsed');
      return (
        <div id="showNav" className={collapsed ? 'sidebar-collapsed' : null}>
          {leftnav && (
            <LeftNav
              collapsed={collapsed}
              handleNavCollapse={this.handleNavCollapse}
            />
          )}
          <div className="wrapper">
            <div id="content">
              {header && (
                <Header
                  toggleMenu={this.toggleMenu}
                  toggleBarCode={this.toggleBarCode}
                />
              )}
              {!this.state.isBarCodeVisible ? (
                <AuthorizationRoute
                  path={this.props.location.pathname}
                  LoadedComponent={() => <LoadedComponent {...this.props} />}
                />
              ) : (
                <BarCodeScreen closeBarModal={this.closeBarModal} />
              )}
              {footer && <Footer />}
            </div>
          </div>
        </div>
      );
    }
  };
}

export default AdminLayout;

const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
